export const routes = (prefix) => [
    {
        path: `/${prefix}/completed-investigations`,
        name: `${prefix}.completed-investigations.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.completed-investigations.index`,
                PageDescription: "Radiology: Completed Investigations",
            },
        },
    },
];
